import store from '@/store/index'

function getCharityId() {
  return store.state.auth.activeCharityId
}

function getActiveCharity(allCharities = [], useDefaultFirst = false) {
  return allCharities.reduce((res, val) => {
    return val.charity_id === getCharityId() ? val : res;
  }, useDefaultFirst ? (allCharities.length ? allCharities[0] : null) : null);
}

export {getCharityId, getActiveCharity};